import React from 'react';
import { useTranslation } from 'react-i18next';
import './Community.css';

const Community = () => {
  const { t } = useTranslation();
  return (
    <section className="community">
      <div className="container">
        <div className="community-content">
          <div className="community-text" data-aos="fade-right">
            <h2 className="community-title">{t('community.title')}</h2>
            <p className="community-description">{t('community.text')}</p>
            <a href="#comunidade" className="community-link">{t('community.action')}</a>
          </div>
          <div className="community-image" data-aos="fade-left">
            <picture>
              <source type="image/webp" srcSet="/images/ban_03.webp" />
              <img 
                src="/images/ban_03.png" 
                alt={t('community.imgAlt')} 
              />
            </picture>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Community;


